import './SignInScreen.scss';
import { useContext } from 'react';

import { GlobalStateContext } from '../../../contexts/GlobalState';
import { Localized } from '../../../utilities/localizedStrings';
import { configService } from '../../../services/configService';
import { Spinner } from '../Spinner/Spinner';
import { ErrorMessageBar } from '../ErrorMessageBar/ErrorMessageBar';
import { BrandGlyph } from '../../icons/BrandGlyph';
import { MicrosoftSignInButton } from './MicrosoftSignInButton';

function envFromAppId(appId) {
    if (!appId) return { code: 'LOCAL', kind: 'dev' };
    const upper = appId.toUpperCase();
    if (upper.includes('PROD') || /CAP\d+/i.test(upper)) return { code: upper, kind: 'prod' };
    if (upper.includes('QA') || /CAQ\d+/i.test(upper)) return { code: upper, kind: 'qa' };
    return { code: upper, kind: 'dev' };
}

export function SignInScreen({ isSigningIn, signInError, setIsSigningIn, setSignInError }) {
    const [state] = useContext(GlobalStateContext);
    const env = envFromAppId(configService.appId);
    const buildNumber = process.env.REACT_APP_BUILD_NUMBER || 'local';

    const envModifier = `cw-SignInScreen__env-pill--${env.kind}`;

    return (
        <div className={`cw-SignInScreen ${state.isDarkMode ? 'cw-SignInScreen--dark' : ''}`}>
            <main className="cw-SignInScreen__panel">
                <section
                    className="cw-SignInScreen__card"
                    role="region"
                    aria-labelledby="cw-signin-title"
                >
                    <div className="cw-SignInScreen__brand">
                        <BrandGlyph className="cw-SignInScreen__glyph" />
                        <span className="cw-SignInScreen__wordmark">Collabspace</span>
                        <span className="cw-SignInScreen__brand-sub">Admin</span>
                    </div>

                    <p className="cw-SignInScreen__eyebrow">Collabware internal</p>
                    <h1 id="cw-signin-title" className="cw-SignInScreen__title">
                        Welcome back.
                    </h1>
                    <p className="cw-SignInScreen__body">
                        {Localized.get('authentication-signin-message')}
                    </p>

                    <ErrorMessageBar errorInfo={signInError} />

                    {isSigningIn ? (
                        <div className="cw-SignInScreen__spinner">
                            <Spinner
                                label={Localized.get('authentication-signingIn')}
                                appendEllipsis
                            />
                        </div>
                    ) : (
                        <>
                            <p className="cw-SignInScreen__divider">
                                <span>Continue with</span>
                            </p>
                            <MicrosoftSignInButton
                                setIsSigningIn={setIsSigningIn}
                                setSignInError={setSignInError}
                            />
                        </>
                    )}

                    <p className="cw-SignInScreen__fine">
                        Access is restricted to authorized Collabware personnel.
                        Need help? Contact Cloud Ops.
                    </p>
                </section>
            </main>

            <footer className="cw-SignInScreen__env-foot" aria-label="Build information">
                <span className={`cw-SignInScreen__env-pill ${envModifier}`}>
                    <span className="cw-SignInScreen__env-dot" />
                    {env.code}
                </span>
                <span className="cw-SignInScreen__env-sep">·</span>
                <span className="cw-SignInScreen__build">build {buildNumber}</span>
            </footer>
        </div>
    );
}
